module.exports = __webpack_public_path__ + "img/3.7ef51f39.jpg";